import OfferStorage from './OfferStorage'
import ApiClient from '../../api/src/ApiClient'
import Product from '../../products/src/product/Product';
import SearchBuilder from  '../../products/src/search/SearchBuilder';

export default {
  namespaced: true,

  state: {
    products: OfferStorage.getProducts(),
    markupType: OfferStorage.loadParam('markupType'),
    markupValue: OfferStorage.loadParam('markupValue'),
  },

  mutations: {
    async addProduct(state, param) {
      OfferStorage.addProduct(param.productId, param.variantId, 1, -1);
      this.dispatch("addNotification",{key:"newOfferProduct",message:param});
      state.products = OfferStorage.getProducts();
    },

    removeProduct(state, variantId) {
      OfferStorage.removeProduct(variantId);
      state.products = OfferStorage.getProducts();
    },

  },

  actions: {

    async offers({}) {
      return await apiClient.get('api/offers?offset=0&limit=200')
    },

    async removeOffer({}, id) {
      await apiClient.get('api/offer/' + id + '/remove');
    },

    async offer({}, params) {
      let offer = await apiClient.get('api/offer/' + params.id );
      let builder = new SearchBuilder();
      builder.addProductIds(offer.positions.map(p => p.product_id));
      builder.addPage(1, 500);
      let result = await apiClient.post("products/search", builder.build());
      for (let position of offer.positions) {
        let searchProduct = result.documentList.find(s => s.Id == position.product_id);
        position.product = Product.buildProduct(searchProduct, params.attributes, params.prices, params.group);
      }
      return offer;
    },

    async saveoffer({}, request) {
      let result = await apiClient.post('api/offer', request);
      OfferStorage.clear();
      return result;
    },

    async addOfferToBasket({}, offerId) {
      return await apiClient.get('api/cart/offer/' + offerId);
    },

    save({commit, state}, product) {
      if (product.cart_quantity <= 0) {
        OfferStorage.removeProduct(product.variantId);
      } else {
        OfferStorage.addProduct(product.id, product.variantId, product.cart_quantity, product.setPrice);
      }
      state.products = OfferStorage.getProducts()
      OfferStorage.saveParams(state.markupType, state.markupValue);
    },


    async add({commit, state}, params) {
      commit('addProduct', params);
    },

    async remove({commit, state}, variantId) {
      commit('removeProduct', variantId);
    },

    async clear({commit, state}) {
      OfferStorage.clear();
      state.products = OfferStorage.getProducts();
    },

    async getDataList({state},params) {
      let builder = new SearchBuilder();
      builder.addProductIds(state.products.map(p => p.id));
      builder.addPage(1, 500);
      let result = await apiClient.post("products/search", builder.build());

      return result.documentList.map(s => {
        let pr = Product.buildProduct(s, params.attributes, params.prices, params.group);
        pr.cart_quantity = state.products.find(p => p.id == pr.id).quantity;
        pr.setPrice = state.products.find(p => p.id == pr.id).setPrice;
        return pr;
      });

    },

  }

}



// WEBPACK FOOTER //
// ./src/components/offer/src/OfferStore.js